"use client";

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
} from "@/ui/components/ui/dialog";
import ModalLayout from "./modal-layout";

interface ModalContainerProps {
  children: React.ReactNode;
  onClose?: () => void;
  title?: string;
  maxWidth?: number;
}

const ModalContainer = ({ children, onClose, title, maxWidth }: ModalContainerProps) => {
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    if (!newOpen) {
      onClose?.();
    }
  };

  const handleClose = () => {
    handleOpenChange(false);
  };

  if (!mounted) return null;

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-w-4xl max-h-[90vh] p-0"
        style={maxWidth ? { maxWidth: `${maxWidth}px` } : undefined}
        onInteractOutside={(e) => {
          e.preventDefault();
          handleOpenChange(false);
        }}
        hideCloseButton={true}
      >
        <ModalLayout
          title={title}
          onClose={handleClose}
        >
          {children}
        </ModalLayout>
      </DialogContent>
    </Dialog>
  );
};

export default ModalContainer;
